<template>
  <b-form @submit.prevent="onSubmit">
    <header class="card-header phairify-h2-bold d-flex align-items-center justify-content-between px-0 pb-3 mb-3">
      <div class="card_title v2_font_size_20 ">Select Preferences</div>
      <div>
        <b-button variant="v2_primary" type="submit">Apply</b-button>
        <b-button variant="v2_white" class="ml-2" @click="onCancel">Cancel</b-button>
      </div>
    </header>
    <b-checkbox-group  v-model="selectedIds" class="phairify-no-outline-on-focus v2_control_checkbox_group" >
      <b-row
        v-for="question in optionalQuestions"
        :key="question.id"
        class="mb-1"
      >
        <b-col cols="10" class="v2_font_size_20 v2_font_weight_semibold">{{ question.label }}</b-col>
        <b-col
          cols="auto"
          class="d-inline-flex justify-content-center align-items-center"
        >
          <b-form-checkbox :value="question.id"/>
        </b-col>
      </b-row>
    </b-checkbox-group>
  </b-form>
</template>

<script>
export default {
  name: 'OptionalPreferencesSelector',
  props: {
    optionalQuestions: {
      type: Array,
      required: true,
    },
    initialSelectedIds: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      selectedIds: [...this.initialSelectedIds],
    };
  },
  methods: {
    onSubmit: function () {
      this.$emit('change-selected', this.selectedIds);
    },
    onCancel: function () {
      this.$emit('change-canceled');
    },
  },
};
</script>

<style>
.card-header {}
</style>
